// The Custom Cohort adjust-job payload (contract 27 §6.1 #5, BE-27-04).
//
// v3 encodes 13 top-level fields of BACKEND JOB WIRING inside a component
// (`CustomCohortCreate.vue:69–90`). The only user input in the whole body is
// `parameters.event_slug_names` (`:77`); everything else is a literal. It lives here as a frozen
// module constant so no component ever restates it, and so BE-27-04 (`POST
// /workspaces/{ws}/cohorts/custom { event_slug_names }`) has exactly one call site to delete.

export interface CustomCohortJobParameters {
  event_slug_names: string[]
  app_token: string
  index: string
  dimensions: string
  attribution_type: string
  attribution_source: string
}

export interface CustomCohortJob {
  raw_data_type: string
  raw_data_name: string
  api_function_name: string
  raw_data_source: string
  is_default: boolean
  api_function_module: string
  parameters: CustomCohortJobParameters
  additional_parameters: Record<string, never>
  default_date_interval: Record<string, never>
  initial_date_interval: Record<string, never>
  conditions: Record<string, never>
  custom_fields: Record<string, never>
  default_refresh_interval: string
}

/**
 * Byte-for-byte the v3 body minus the event list. `raw_data_name` is a backend record label, not
 * UI copy — it is never rendered, so it is not an i18n key.
 */
export const CUSTOM_COHORT_JOB: CustomCohortJob = {
  raw_data_type: 'custom_adjust_mmp_cohort',
  raw_data_name: 'Multi-Event Cohort Config',
  api_function_name: 'get_adjust_cohort_data',
  raw_data_source: 'adjust_account',
  is_default: false,
  api_function_module: 'adjust_main',
  parameters: {
    event_slug_names: [],
    app_token: '',
    index: 'day',
    dimensions: 'app',
    attribution_type: 'click',
    attribution_source: 'dynamic',
  },
  additional_parameters: {},
  default_date_interval: {},
  initial_date_interval: {},
  conditions: {},
  custom_fields: {},
  default_refresh_interval: '0 years 0 mons 3 days 0 hours 0 mins 0.0 secs',
}
